import Vue from "vue";
import ProductService from "@/services/ProductService";

const state = () => ({
  /*
   * Feed
   */
  feedProducts: [],
  feedPage: 0,
  feedReset: 0,

  /*
   * New
   */
  newProducts: [],
  newPage: 0,

  /*
   * Trending
   */
  trendingProducts: [],
  trendingPage: 0,

  /*
   * Likes
   */
  likedProducts: [],

  /*
   * Sort
   */
  sortOptions: ["Newest", "Lowest Price", "Highest Price", "Best"],
  sortBackend: ["newest", "lowest", "highest", "random"],
  sort: "Best",

  /*
   * Filter
   */
  includesAll: true,

  /*
   * Guest
   */
  guestFeedProducts: [],
  guestFeedPage: 0,
  guestFeedReset: 0,
  guestFeedSort: 0,

  pageSize: 12,
});

const getters = {
  getProductById: (state) => (id) => {
    const allProducts = [
      ...state.feedProducts,
      ...state.newProducts,
      ...state.trendingProducts,
      ...state.likedProducts,
    ];
    const foundProduct = allProducts.find((p) => p.id === id);
    if (foundProduct === undefined) {
      return null;
    } else {
      return foundProduct;
    }
  },

  /*
   * Feed
   */
  getFeedProducts: (state) => {
    return state.feedProducts;
  },
  getFeedReset: (state) => {
    return state.feedReset;
  },

  /*
   * New
   */
  getNewProducts: (state) => {
    return state.newProducts;
  },

  /*
   * Trending
   */
  getTrendingProducts: (state) => {
    return state.trendingProducts;
  },

  /*
   * Likes
   */
  getLikedProducts: (state) => {
    return state.likedProducts;
  },
  hasLikedProducts: (state) => {
    return state.likedProducts.length > 0;
  },
  isProductLiked: (state) => (product) => {
    return state.likedProducts.findIndex((p) => p.id === product.id) !== -1;
  },

  /*
   * Sort by
   */
  getSort: (state) => {
    return state.sort;
  },
  getSortOptions: (state) => {
    return state.sortOptions;
  },
  getSortBackend: (state) => {
    const index = state.sortOptions.findIndex((s) => s === state.sort);
    return state.sortBackend[index];
  },

  /*
   * Filter
   */
  getIncludesAll: (state) => {
    return state.includesAll;
  },

  /*
   * Guest
   */
  getGuestFeedProducts: (state) => {
    return state.guestFeedProducts;
  },
  getGuestFeedReset: (state) => {
    return state.guestFeedReset;
  },
  getGuestFeedSort: (state) => {
    return state.guestFeedSort;
  },
};

const actions = {
  clearAllProducts({ commit }) {
    commit("clearAll");
  },

  /*
   * Feed
   */
  loadFeed({ commit, state }, data) {
    data.limit = state.pageSize;
    data.offset = state.feedPage * state.pageSize;
    return ProductService.getFeed(data).then(
      (response) => {
        const products = response.data;
        commit("feedNextPage");
        commit("appendFeedProducts", products);
        return Promise.resolve(products);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },
  resetFeed({ commit }) {
    commit("clearFeed");
  },

  /*
   * New
   */
  loadNew({ commit, state }) {
    return ProductService.getNew({
      limit: state.pageSize,
      offset: state.newPage * state.pageSize,
    }).then(
      (response) => {
        const products = response.data;
        commit("newNextPage");
        commit("appendNewProducts", products);
        return Promise.resolve(products);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },

  /*
   * Trending
   */
  loadTrending({ commit, state }) {
    return ProductService.getTrending({
      limit: state.pageSize,
      offset: state.trendingPage * state.pageSize,
    }).then(
      (response) => {
        const products = response.data;
        commit("trendingNextPage");
        commit("appendTrendingProducts", products);
        return Promise.resolve(products);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },

  /*
   * Likes
   */
  fetchLikedProducts({ commit }) {
    return ProductService.getAllLikedProducts().then(
      (response) => {
        const likedProducts = response.data;
        commit("setLikedProducts", likedProducts);
        return Promise.resolve(likedProducts);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },
  likeProduct({ commit }, product) {
    commit("appendLikedProduct", product);
    return ProductService.likeProduct(product.id);
  },
  unlikeProduct({ commit }, product) {
    commit("removeLikedProduct", product);
    return ProductService.unlikeProduct(product.id);
  },

  /*
   * Sort by
   */
  updateSort({ commit }, sort) {
    commit("setSort", sort);
  },

  /*
   * Filter
   */
  updateIncludesAll({ commit }, includesAll) {
    commit("setIncludesAll", includesAll);
  },

  /*
   * Guest
   */
  loadGuestFeed({ commit, state }, data) {
    data.limit = state.pageSize;
    data.offset = state.guestFeedPage * state.pageSize;
    // var promise = null;
    // if (state.guestFeedSort == 0) {
    const promise = ProductService.getDiscover(data);
    // } else {
    // const promise = ProductService.getNew(data);
    // }
    return promise.then(
      (response) => {
        const products = response.data;
        commit("guestFeedNextPage");
        commit("appendGuestFeedProducts", products);
        return Promise.resolve(products);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },
  resetGuestFeedSort({ commit }) {
    commit("clearGuestFeed");
  },
  updateGuestFeedSort({ commit }, sort) {
    commit("setGuestFeedSort", sort);
  },
};

const mutations = {
  clearAll(state) {
    state.feedProducts = [];
    state.feedPage = 0;
    state.newProducts = [];
    state.newPage = 0;
    state.trendingProducts = [];
    state.trendingPage = 0;
    state.likedProducts = [];
    state.guestFeedProducts = [];
    state.guestFeedPage = 0;
  },

  /*
   * Feed
   */
  feedNextPage(state) {
    state.feedPage += 1;
  },
  appendFeedProducts(state, products) {
    state.feedProducts.push(...products);
  },
  clearFeed(state) {
    state.feedProducts = [];
    state.feedPage = 0;
    Vue.set(state, "feedReset", state.feedReset + 1);
  },

  /*
   * New
   */
  newNextPage(state) {
    state.newPage += 1;
  },
  appendNewProducts(state, products) {
    state.newProducts.push(...products);
  },

  /*
   * Trending
   */
  trendingNextPage(state) {
    state.trendingPage += 1;
  },
  appendTrendingProducts(state, products) {
    state.trendingProducts.push(...products);
  },

  /*
   * Likes
   */
  setLikedProducts(state, likedProducts) {
    state.likedProducts = likedProducts;
  },
  appendLikedProduct(state, likedProduct) {
    state.likedProducts.unshift(likedProduct);
  },
  removeLikedProduct(state, likedProduct) {
    const index = state.likedProducts.findIndex(
      (p) => p.id === likedProduct.id
    );
    if (index > -1) {
      state.likedProducts.splice(index, 1);
    }
  },

  /*
   * Sort by
   */
  setSort(state, sort) {
    state.sort = sort;
  },

  /*
   * Filter
   */
  setIncludesAll(state, includesAll) {
    state.includesAll = includesAll;
  },

  /*
   * Guest
   */
  guestFeedNextPage(state) {
    state.guestFeedPage += 1;
  },
  appendGuestFeedProducts(state, products) {
    state.guestFeedProducts.push(...products);
  },
  setGuestFeedSort(state, sort) {
    state.guestFeedSort = sort;
  },
  clearGuestFeed(state) {
    state.guestFeedProducts = [];
    state.guestFeedPage = 0;
    Vue.set(state, "guestFeedReset", state.guestFeedReset + 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
